"use client";

// src/drip.tsx
import { drip } from "@nextui-org/theme";
import { Fragment, jsx } from "react/jsx-runtime";
var Drip = (props) => {
  const { drips, ...otherProps } = props;
  const classNames = drip();
  if (!drips || !Array.isArray(drips) || drips.length < 1) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children: drips.map(({ key, ...dripProps }) => /* @__PURE__ */ jsx("span", { className: classNames, ...otherProps, ...dripProps }, key)) });
};
Drip.displayName = "NextUI.Drip";
var drip_default = Drip;

export {
  drip_default
};
